import { logos } from 'common'
import { YoloTokenCSS } from './YoloTokenCSS.styled'
import isEmail from 'validator/lib/isEmail'
import { isAddress } from '@ethersproject/address'
import { useUser } from 'hooks/user/useUser'
import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useAccessToken } from 'hooks/user/useAccessToken'
import { API } from 'constants/apiEndPoints'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { LONG_DASH } from 'constants'
import { Helmet } from 'react-helmet'
import twitterShare from 'twitter-share'
import { useScrollTo } from 'hooks/useScrollTo'

export const YoloToken = () => {
  const { account } = useUser('wallet')
  const [email, setEmail] = useState('')
  const [address, setAddress] = useState('')
  const [captchaToken, setCaptchaToken] = useState('')
  const [errorMsg, setErrorMsg] = useState([])
  const [submitSt, setSubmitSt] = useState('submit')
  const { accessToken } = useAccessToken(account)
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { scrollRef, scrollToRef } = useScrollTo()

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available')
      return
    }
    const token = await executeRecaptcha('signIn')
    setCaptchaToken(token)
  }, [executeRecaptcha])

  useEffect(() => {
    handleReCaptchaVerify()
  }, [handleReCaptchaVerify])

  const onEmailChange = (e) => {
    const value = e.target.value
    setErrorMsg([])
    setEmail(value)
  }
  const onAddressChange = (e) => {
    const value = e.target.value
    setErrorMsg([])
    setAddress(value)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setErrorMsg([])

    if (!isEmail(email)) {
      setErrorMsg((prev) => [...prev, ' Please enter a valid email address'])
      return
    }
    if (!isAddress(address)) {
      setErrorMsg((prev) => [...prev, ' Please enter a valid ethereum address'])
      return
    }
    const payload = {
      ethAddress: address,
      email: email,
      captchaToken,
    }
    setSubmitSt('waiting')
    const rawRes = await axios
      .post(`${API.YOLO_TOKEN_WAITLIST}`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .catch((err) => {
        setSubmitSt('submit')
        setErrorMsg((prev) => [...prev, 'comunication error, try later'])
        return
      })
    const response = rawRes?.data
    if (response.status === 'error') {
      setErrorMsg((prev) => [...prev, response.error])
      setSubmitSt('submit')
      return
    }
    setSubmitSt('success')
    getWaitListCounter()
  }

  const openDocsInNewTab = () => {
    const url = 'https://docs.yolorekt.finance/docs/yolo-token/overview'
    const newWindow = window.open(url, '_blank')
    newWindow.focus()
  }

  // Counter section
  const [whiteListCount, setWhiteListCount] = useState(LONG_DASH)
  const getWaitListCounter = async () => {
    const res = await axios.get(API.YOLO_TOKEN_WAITLIST_COUNTER).catch((error) => {
      console.log('ACZ: getWaitListCounter error', error)
      return 'error'
    })
    if (res === 'error') return
    const count = res.data.body.whiteListCount
    setWhiteListCount(count)
  }

  useEffect(() => {
    getWaitListCounter()
  }, [])
  // Counter section

  // Twitter share
  const shareTwitter = (e) => {
    e.preventDefault()
    const params = {
      url: 'https://yolorekt.finance/game/yolo_token',
      text: 'I just joined the the waiting list for $YOLO, the official token of @playyolorekt launching soon. Join the list, Tweet to guarantee your spot in the pre-sale, and learn more about $YOLO here: ',
    }
    const tweetLink = twitterShare(params)
    const a = document.createElement('a')
    a.href = `javascript:window.open('${tweetLink}','_blank','height=400,width=600');`
    a.click()
    a.remove()
  }
  // Twitter share

  return (
    <YoloTokenCSS>
      <Helmet>
        <title>$YOLO</title>
      </Helmet>
      <div className='scroll_wrapper'>
        <div className='yolo_token_page_wrapper'>
          <div className='yt_page_left'>
            <h1>COMING SOON</h1>
            <h2>YOLOREKT Token Issuance</h2>
            <div className='top_alert' onClick={scrollToRef}>
              <span>
                There are <b>100 spots</b> exclusively reserved for YOLOREKT users to contribute to the presale of $YOLO
                at a lower minimum of $500. <div className='fake_link'>Act fast before they're gone</div>
              </span>
            </div>
            <div className='yt_logo_full'>
              <img alt='' src={logos.yolo_token_full_logo_2} />
            </div>
            <form className={submitSt === 'success' && 'submit_result_tweet'}>
              <ContentSwitcherByState
                noWrapper
                activeState={submitSt}
                stateObject={{
                  success: (
                    <>
                      <fieldset>
                        <label>Thanks! You're now on our waiting list.</label>
                      </fieldset>
                      <fieldset>
                        <p>
                          While you're waiting, Tweet about this and you'll be <b>guaranteed a spot in the pre-sale</b>.
                        </p>
                        <button className='tweet' onClick={shareTwitter}>
                          Tweet
                        </button>
                      </fieldset>
                    </>
                  ),
                  default: (
                    <>
                      <fieldset>
                        <label>Join the waiting list and be the first to know:</label>
                      </fieldset>
                      <fieldset>
                        <input
                          type='text'
                          placeholder='Enter your email address'
                          value={email}
                          onChange={onEmailChange}
                        />
                        <input
                          type='text'
                          placeholder='Enter your wallet address to whitelist'
                          value={address}
                          onChange={onAddressChange}
                        />
                      </fieldset>
                      <fieldset>
                        <button onClick={onSubmit}>
                          <ContentSwitcherByState
                            noWrapper
                            activeState={submitSt}
                            stateObject={{
                              submit: 'Submit',
                              waiting: <SingleDataLoader loading={true} data={''} />,
                              success: 'You are in!!',
                            }}
                          />
                        </button>

                        {errorMsg.map((msg) => (
                          <div className='field_error'>{msg}</div>
                        ))}
                      </fieldset>
                    </>
                  ),
                }}
              />
              <div className='waitlist_amount_title'>Currently on waiting list:</div>
              <div className='waitlist_data'>
                <div className='circles'></div>+{whiteListCount}
              </div>
            </form>

            <div className='qanda'>
              <div className='question'>$YOLO</div>
              <div className='answer'>
                Users can also save up to 10% on profitable order fees by paying with $YOLO tokens which provide
                significant rebate on fees.
              </div>

              <div className='question'>What is the distribution?</div>
              <div className='answer'>
                Here are the totals, allocation breakdown, and schedules:
                <div className='yt_table_wrapper'>
                  <div className='subtitle'>Token Details</div>

                  <div className='grid-body token_details'>
                    <div className='grid-content'>
                      {/* <!-- SECTION -->			   */}
                      <div className='table_row'>
                        <label className='token'>
                          <div className='title'>Token:</div>
                          <span>$YOLO (YOLOREKT)</span>
                        </label>
                        <label className='token_supply'>
                          <div className='title'>Total Token Supply:</div>
                          <span>1,000,000,000</span>
                        </label>
                        <label className='team_allocation'>
                          <div className='title'>Team Allocation:</div>
                          <span>16% (Locked for 1 year)</span>
                        </label>
                        <label className='seed_investors_allocation'>
                          <div className='title'>Seed Investors Allocation:</div>
                          <span>40.96% (Locked for 6 months)</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className='subtitle'>Private Issuance Details</div>

                  <div className='grid-body private_dist'>
                    <div className='grid-content'>
                      {/* <!-- SECTION -->			   */}
                      <div className='table_row'>
                        <label className='date'>
                          <div className='title'>Launch Date:</div>
                          <span>August 1, 2023</span>
                        </label>
                        <label className='address'>
                          <div className='title'>Smart Contract Address:</div>
                          <span>TBD</span>
                        </label>
                        <label className='token_price'>
                          <div className='title'>Token Price:</div>
                          <span>$0.04 fixed (approx 0.000021 ETH)</span>
                        </label>
                        <label className='mechanism'>
                          <div className='title'>Mechanism:</div>
                          <span>
                            Though token price for the private sale is fixed, the public sale price will be determined
                            by utilizing a "virtual bonding curve" approach: a linear function with a coefficient of
                            1E-8 applied to total number of tokens sold during the private round will determine the
                            public sale starting price.
                          </span>
                        </label>
                        <label className='min_buy_amount'>
                          <div className='title'>Minimum Buy Amount:</div>
                          <span>$1,000 (valued in ETH at time of sale open)</span>
                        </label>
                        <label className='total_token_all'>
                          <div className='title'>Total Token Allocation:</div>
                          <span>3% (30M)</span>
                        </label>
                        <label className='vesting'>
                          <div className='title'>Vesting:</div>
                          <span>6-month lockup followed by linear, continuous vesting over 10 months</span>
                        </label>
                        <label ref={scrollRef} className='yolorekt_users'>
                          <div className='title'>YOLOREKT Users:</div>
                          <span>
                            <b>100 spots</b> will be reserved for YOLOREKT users who are able to contribute to the
                            presale of $YOLO at $500 minimum - first come, first served. Eligibility criteria will be
                            available soon on this page.
                            {/* <button className='reserve_100'>Reserve your spot now</button>
                            <div className='reserve_100_success'>
                              <b>You're in the que!</b> We'll let you know if you're eligible to contribute to the
                              presale of $YOLO at $500 minimum.
                            </div> */}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className='subtitle'>Public Issuance Details</div>

                  <div className='grid-body public_dist'>
                    <div className='grid-content'>
                      {/* <!-- SECTION -->			   */}
                      <div className='table_row'>
                        <label className='date'>
                          <div className='title'>Launch Date:</div>
                          <span>August 2023 (TBD)</span>
                        </label>
                        <label className='address'>
                          <div className='title'>Smart Contract Address:</div>
                          <span>TBD</span>
                        </label>
                        <label className='mechanism'>
                          <div className='title'>Mechanism:</div>
                          <span>
                            One-way token bonding curve. The bonding function will be linear and its coefficient will be
                            set at 1E-8.
                          </span>
                        </label>
                        <label className='token_price'>
                          <div className='title'>Starting Token Price:</div>
                          <span>TBD based on virtual bonding curve from private issuance</span>
                        </label>
                        <label className='total_token_all'>
                          <div className='title'>Total Token Allocation:</div>
                          <span>10% (100M)</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className='subtitle'>Long-term Airdrop Allocations</div>

                  <div className='grid-body airdrop_allocations'>
                    <div className='grid-header'>
                      <label>Reward Type</label>
                      <label>Allocations</label>
                      <label>Distribution</label>
                    </div>
                    <div className='grid-content'>
                      {/* <!-- ROW -->			   */}
                      <div className='table_row'>
                        <label>Achievements on YOLOREKT</label>
                        <label>2%</label>
                        <label>
                          First month: 0.34%
                          <br />
                          Subsequent months: 0.154%
                        </label>
                      </div>

                      {/* <!-- ROW -->			   */}
                      <div className='table_row'>
                        <label>Referrals</label>
                        <label>10% of fees paid via $YOLO will be allocated for referrals</label>
                        <label>
                          Users opt $YOLO: 40%
                          <br />
                          Users opt non-$YOLO: 20% commission
                        </label>
                      </div>

                      {/* <!-- ROW -->			   */}
                      <div className='table_row'>
                        <label>Early YOLOREKT Users</label>
                        <label>0.2%</label>
                        <label>To be distributed at Public Issuance</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='question'>Tell me more...</div>
              <div className='answer'>
                <button className='see_more' onClick={openDocsInNewTab}>
                  See more FAQs about $YOLO
                </button>
              </div>
            </div>
          </div>
          <div className='yt_page_right'>
            <div className='yt_logo_full'>
              <img alt='' src={logos.yolo_token_full_logo_2} />
            </div>

            <div className='qanda'>
              <div className='question'>About YOLOREKT</div>
              <div className='answer'>
                <div className='callout_boxes'>
                  <div className='box'>
                    <div className='box_title'>Total Volume</div>
                    <div className='box_value'>+500M</div>
                  </div>
                  <div className='box'>
                    <div className='box_title'>Fees generated</div>
                    <div className='box_value'>+100K</div>
                  </div>
                </div>
                <p>
                  Launched in 2019 as 3-minute prediction platform on ETH, YOLOREKT has evolved into the ultimate
                  super-degen leveraged gaming platform. YOLOREKT designs, builds, and provides advanced unique
                  leveraged gaming experiences that offer killer 1000x leverage using crypto, synthetic stocks, ETFs,
                  and more.
                </p>

                <p>
                  YOLOREKT has a <b>daily average of over 10 Million in volume</b> and{' '}
                  <b>more than 500 Million total volume</b> since its launch, in a matter of months. YOLOREKT's growth
                  has been consistent and exponential, inching closer to a profitable platform, and month by month
                  already being cash flow positive.
                </p>
                <p>
                  YOLOREKT boasts of gamified innovation on financial products like never before; it's been called the
                  home for brave degens.
                </p>
              </div>
            </div>
            <div className='landing_level investors'>
              <div className='section_heading'>Seed Investors</div>
              <div className='logos'>
                <a href='https://panteracapital.com' target='blank' className='pantera'>
                  <div className='logo'></div>
                  <span>Pantera Capital</span>
                </a>
                <a href='https://www.cluster.vc' target='blank' className='cluster'>
                  <div className='logo'></div>
                  <span>Cluster Capital</span>
                </a>
                <a href='https://lemniscap.com' target='blank' className='lemniscap'>
                  <div className='logo'></div>
                  <span>LemnisCap</span>
                </a>
                <a href='https://www.deepventures.io' target='blank' className='deepventures'>
                  <div className='logo'></div>
                  <span>Deep Ventures</span>
                </a>
                <a href='https://www.angeldao.org' target='blank' className='angeldao'>
                  <div className='logo'></div>
                  <span>AngelDAO</span>
                </a>
                <a href='https://http://www.kretos.ventures/' target='blank' className='kretos'>
                  <div className='logo'></div>
                  <span>Kretos Ventures</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <div id='landing-details'>
            <div id='priv-terms'>
              <a href='https://docs.yolorekt.finance/docs/legal/privacy-policy' target='blank'>
                Privacy Policy
              </a>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              <a href='https://docs.yolorekt.finance/docs/legal/terms-of-service' target='blank'>
                Terms of Service
              </a>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              <a href='https://docs.yolorekt.finance' target='blank'>
                Docs
              </a>
            </div>

            <div id='copyright'>
              <strong>
                © Copyright
                <script type='text/javascript'>var year = new Date();document.write(year.getFullYear());</script>
                2023
              </strong>
              All rights reserved
            </div>
          </div>

          <div className='about'>
            YOLOREKT designs, builds, and provides advanced next-degen leveraged gaming experiences that offer killer
            incentives, royalties, and leverage up-to 1000x with no minimum portfolio balance.
            <div>
              Visit and play YOLOREKT @{' '}
              <a href='https://yolorekt.finance' target='blank'>
                https://yolorekt.finance
              </a>
            </div>
          </div>

          <div id='landing-social'>
            <a
              href='https://twitter.com/playyolorekt'
              target='blank'
              rel='noopener noreferrer'
              className='icon twitter'
            >
              {''}
            </a>
            <a href='https://vm.tiktok.com/ZTdmEw6xk/' target='blank' rel='noopener noreferrer' className='icon tiktok'>
              {''}
            </a>
            <a href='https://medium.com/yolorekt' target='blank' rel='noopener noreferrer' className='icon medium'>
              {''}
            </a>
            <a
              href='https://t.me/joinchat/NBBv1hQmV26flFM_5MD4_w'
              target='blank'
              rel='noopener noreferrer'
              className='icon telegram'
            >
              {''}
            </a>
            <a href='https://discord.gg/yolorekt' target='blank' rel='noopener noreferrer' className='icon discord'>
              {''}
            </a>
            <a
              href='mailto:support@yolorekt.com?Subject=Hello%20again'
              target='blank'
              rel='noopener noreferrer'
              className='icon email'
            >
              {''}
            </a>
          </div>
        </footer>
        {/* </div> */}
      </div>
    </YoloTokenCSS>
  )
}
